import axios from "axios";
import { createQuery } from "../utils";
import { authHeader } from "../utils/auth-header";

const extract = ({ data }) => data;

// Adding interceptor to show login page to unauthorized user
axios.interceptors.response.use(
    successRes => {
        return successRes;
    },
    error => {
        const { status } = error.response;
        if (status === 401) {
            window.location = "/hedera/login";
        } else {
            return Promise.reject(error);
        }
    }
);

let ip = "";

export const fetchClientIp = async () => {
    let data = "";
    await axios.get("https://www.cloudflare.com/cdn-cgi/trace").then(res => (data = res));
    console.log("IP ADDRESS: ", data.data.split("\n")[2].slice(3));
    ip = data.data.split("\n")[2].slice(3);
};

export const fetchConfig = async () => {
    return axios.get("/api/config").then(extract);
};

export const login = (email, password) => {
    return axios.post("/api/auth/login", { username: email, password }).then(extract);
};

export const signup = user => {
    return axios.post("/api/auth/signup", { ...user }).then(extract);
};

export const resetPassword = email => {
    return axios.post("/api/auth/password-reset", { email }).then(extract);
};

export const updatePassword = (password, token) => {
    return axios.post("/api/auth/password-update", { password, token }).then(extract);
};

export const saveProfile = (profile, userId) => {
    return axios.put(`/api/users/${userId}`, { ...profile }, { headers: authHeader() }).then(extract);
};

export const fetchUserAccounts = userId => {
    return axios.get(`/api/users/${userId}/accounts`, { headers: authHeader() }).then(extract);
};

export const addUserAccount = (account, userId) => {
    return axios.post(`/api/users/${userId}/accounts`, { ...account }, { headers: authHeader() }).then(extract);
};

export const updateUserAccount = (account, userId) => {
    return axios
        .put(`/api/users/${userId}/accounts/${account.accountId}`, { ...account }, { headers: authHeader() })
        .then(extract);
};

export const removeUserAccount = (account, userId) => {
    return axios
        .delete(`/api/users/${userId}/accounts/${account.accountId}`, { headers: authHeader() }, {})
        .then(extract);
};

export const search = term => {
    return axios.get(`/api/search?term=${term}`).then(extract);
};

/*
export const fetchPriceTrend = (period, currencyPair = 'HBAR-USD') => {
	console.log('calling api fetchPriceTrend for = ', period);
	return axios.get(`/api/stats/price?currency_pair=${currencyPair}&period=${period}`).then(extract);
};
*/

export const fetchPriceTrend = (period, currencyPair = "HBAR-USD") => {
    return axios.get(`/api/prices/hbar`).then(extract);
};

export const fetchGecko = () => {
    return axios
        .get("https://api.coingecko.com/api/v3/simple/price?ids=hedera-hashgraph&vs_currencies=USD")
        .then(extract);
};

export const fetchNodes = period => {
    return axios.get(`/api/stats/nodes?period=${period}`).then(extract);
};

export const fetchNews = () => {
    return axios.get("/api/news").then(extract);
};

export const fetchTransactionTypes = period => {
    return axios.get(`/api/stats/transaction-types?period=${period}`).then(extract);
};

export const fetchTransactionVolume = period => {
    return axios.get(`/api/stats/transaction-volume?period=${period}`).then(extract);
};

export const fetchAccountCreationVolume = period => {
    return axios
        .get(`/api/stats/transaction-volume?period=${period}&transactionTypes=CRYPTO_CREATE_ACCOUNT`)
        .then(extract);
};

export const fetchTransactionValues = period => {
    return axios.get(`/api/stats/transaction-value/hbar?period=${period}`).then(extract);
};

export const fetchDapps = () => {
    return axios.get(`/api/dapps`).then(extract);
};

export const fetchStats = () => {
    return axios.get(`/api/stats/counts`).then(extract);
};

export const fetchTxnCount = () => {
    return axios.get(`/api/stats/counts/txn`).then(extract);
};

export const fetchAccCount = () => {
    return axios.get(`/api/stats/counts/accounts`).then(extract);
};

export const fetchAccount = id => {
    return axios.get(`/api/accounts/${id}`).then(extract);
};

export const fetchAccountBalance = id => {
    return axios.get(`/api/accounts/${id}/balance`).then(extract);
};

export const fetchAccountRecentTransactionsCount = id => {
    return axios.get(`/api/accounts/${id}/transaction-count`).then(extract);
};

export const fetchAccountTransfers = (id, query) => {
    return axios.get(`/api/accounts/${id}/transfers?${query}`).then(extract);
};

export const fetchAccountTransactions = (id, query) => {
    return axios.get(`/api/accounts/${id}/transactions?` + query).then(extract);
};

export const fetchAccountBalanceHistory = (id, period) => {
    return axios.get(`/api/accounts/${id}/balance-history?period=${period}`).then(extract);
};

export const fetchAccountFiles = id => {
    return axios.get(`/api/accounts/${id}/files`).then(extract);
    // return Promise.resolve(files)
};

export const fetchAccountTransaction = (txId, acctId) => {
    return axios.get(`/api/accounts/${acctId}/transactions/${txId}`).then(extract);
};

export const fetchTransactions = async query => {
    console.log("LOGGING THE IP IN APIS FETCH TRANSACTIONS: ", ip);
    ip === "" && (await fetchClientIp());
    if (localStorage.getItem("_dguser")) {
        const user = JSON.parse(localStorage.getItem("_dguser"));
        const userQuery = `email=${user.email}&uuid=${user.uuid}&ip=${ip}&`; // ip=${data.data.split('\n')[2].slice(3)}&
        const totalQuery = `${query}&${userQuery}`;
        return axios.get(`/api/transactions?${totalQuery}`).then(extract);
    } else {
        return axios.get(`/api/transactions?${query}&ip=${ip}&`).then(extract);
    }
};

export const fetchTransactionsPieChart = query => {
    return axios.get(`/api/transactions?serviceTypes=TOKEN&period=${query}`).then(extract);
};

export const fetchTransactionsByParams = params => {
    return axios.get(`/api/transactions/?${createQuery(params)}`).then(extract);
};

export const fetchTransaction = txId => {
    return axios.get(`/api/transactions/${txId}`).then(extract);
};

export const fetchRawTransaction = txId => {
    return axios.get(`/api/transactions/${txId}/raw`).then(extract);
};

export const contact = data => {
    return axios.post(`/api/contact-us`, { ...data }).then(extract);
};

export const fetchContracts = query => {
    return axios.get(`/api/contracts?${query}`).then(extract);
};

export const fetchTopics = query => {
    console.log("IN APIS FETCH TOPICS: ", query);
    // return Promise.resolve(topics);
    return axios.get(`/api/topics?${query}`).then(extract);
};

export const fetchTopic = id => {
    console.log("IN APIS FETCH SINGLE TOPIC: ", id);
    // return Promise.resolve(topics);
    return axios.get(`/api/topics/${id}`).then(extract);
};

export const fetchTopicMessages = (id, query) => {
    console.log("IN APIS FETCH TOPIC MESSAGES: ", id, query);
    return axios.get(`/api/topics/${id}/messages?` + query).then(extract);
};

export const fetchAccounts = query => {
    return axios.get(`/api/accounts?${query}`).then(extract);
};

export const fetchContract = id => {
    return axios.get(`/api/contracts/${id}`).then(extract);
};

export const fetchContractTransactions = (id, query) => {
    return axios.get(`/api/contracts/${id}/transactions?` + query).then(extract);
};

export const fetchContractBalance = id => {
    return axios.get(`/api/contracts/${id}/balance`).then(extract);
};

export const fetchContractRecentTransactionsCount = id => {
    return axios.get(`/api/contracts/${id}/transaction-count`).then(extract);
};

export const fetchContractTransfers = (id, query) => {
    return axios.get(`/api/contracts/${id}/transfers?${query}`).then(extract);
};

export const fetchContractBalanceHistory = (id, period) => {
    return axios.get(`/api/contracts/${id}/balance-history?period=${period}`).then(extract);
};

export const fetchContractByteCode = id => {
    return axios.get(`/api/contracts/${id}/byte-code`).then(extract);
};

export const fetchContractTransactionVolume = (id, period) => {
    return axios.get(`/api/contracts/${id}/stats/transaction-volume?period=${period}`).then(extract);
};

export const fetchContractUsersCount = (id, period) => {
    return axios.get(`/api/contracts/${id}/stats/users?period=${period}`).then(extract);
};

// PUBLIC API SELECTION

export const fetchApiCategories = () => {
    // return Promise.resolve(apiCategories);

    return axios.get(`/api/apis/apicategories`).then(extract);
};

export const fetchApiList = () => {
    // return Promise.resolve(apiList);

    return axios.get(`/api/apis/apilist`).then(extract);
};

export const fetchApiParameters = () => {
    // return Promise.resolve(apiList);

    return axios.get(`/api/apis/apiparameters`).then(extract);
};

export const fetchSampleResponse = url => {
    // return Promise.resolve(apiList);
    const index = url.indexOf("api/");
    console.log("IN APIS, FETCH SAMPLE RESPONSE: ", url.slice(index + 4));
    return axios.get(`/api/apis/sampleresponse?url=${url.slice(index + 4)}`).then(extract);
};

// CREATION OF API KEYS

export const createApiKey = () => {
    // return Promise.resolve(apiKeyPair);
    return axios.post(`/api/users/apiKeys`, {}, { headers: authHeader() }).then(extract);
};

export const fetchApiKey = () => {
    // return Promise.resolve(apiKeyPair);
    return axios.get(`/api/users/apiKeys`, { headers: authHeader() }).then(extract);
};

export const deleteApiKey = keyId => {
    return axios.delete(`/api/users/apiKeys/${keyId}`, { headers: authHeader() }).then(extract);
};

export const deactivateApiKey = keyId => {
    return axios.put(`/api/users/apiKeys/${keyId}/deactivate`, {}, { headers: authHeader() }).then(extract);
};

export const activateApiKey = keyId => {
    return axios.put(`/api/users/apiKeys/${keyId}/activate`, {}, { headers: authHeader() }).then(extract);
};

// DAPP PAGE

export const fetchDapp = id => {
    return axios.get(`/api/dapps/${id}`).then(extract);
    // return Promise.resolve(dapp);
};

export const fetchDappContracts = id => {
    return axios.get(`/api/dapps/${id}/contracts`).then(extract);
    // return Promise.resolve(dappContracts);
};

export const fetchDappTransactions = (id, query) => {
    console.log("calling api fetchDappTransactions = ", id);
    return axios.get(`/api/dapps/${id}/transactions?` + query).then(extract);
    // return Promise.resolve(dappTransactions);
};

export const fetchDappTransfers = (id, query) => {
    console.log("calling api fetchDappTransfers = ", id);
    const resp = axios.get(`/api/contracts/${id}/tokentransfers?` + query).then(extract);
    return resp; // axios.get(`/api/contracts/${id}/transfers?` + query).then(extract);
    // return Promise.resolve(dappTransfers);
};

export const fetchDappTokenTransfers = (accountId, query) => {
    console.log("calling api fetchDappTokenTransfers = ", query);
    // const response = axios.get(`/api/tokens/transfers?contractID=${id}&from=0&size=50&sortBy=desc`).then(extract);
    const response = axios.get(`/api/tokens/transfers?` + query).then(extract);
    console.log("RESPONSE IN FETCH DAPP TOKEN TRANSFERS", response);
    return response;

    // return Promise.resolve(dappTransfers);
    // 0.0.61457
};

// TRANSACTION PARAMETERS ON THE CONTRACT CALL PAGE

export const fetchTransactionParams = (contractId, txId) => {
    // const esc = encodeURIComponent;
    // const searchQuery = Object.keys(txId).map((p) => esc(p) + '=' + esc(queryParams[p])).join('&');
    console.log("calling api fetchTransactionParams = ", contractId, txId);
    // return api/contracts/0.0.129557/calls?from=0&size=50&sortBy=desc&transactionID=001295651574748244632119000
    return axios
        .get(`/api/contracts/${contractId}/calls?from=0&size=50&sortBy=desc&transactionID=${txId}`)
        .then(extract);
    // return Promise.resolve(transactionParams);
};

/* -------------------------------- OWN OR CREATE A DAPP -------------------------------- */

export const selectDappToOwn = (id, data) => {
    console.log("calling api selectDappToOwn for ", id);
    return axios.post(`/api/dapps/${id}/select`, { ...data }).then(extract);
};

export const createNewDapp = (id, data) => {
    console.log("calling api createNewDapp for ", id, data);
    const newData = formData(data);
    console.log("THIS IS THE FORM DATA: ", newData);
    // return axios.post(`/api/dapps/${id}/create`, { ...data }).then(extract);
    return axios({
        method: "post",
        url: `/api/dapps/${id}/create`,
        data: newData,
        headers: { "Content-Type": "multipart/form-data" },
    })
        .then(function (response) {
            //handle success
            console.log(response);
            return response;
        })
        .catch(function (response) {
            //handle error
            console.log(response);
            return response;
        });
};

export const dappAddContract = (id, data) => {
    console.log("calling api dappAddContract for ", id, data);
    const newData = formData(data);
    console.log("THIS IS THE FORM DATA IN DAPP ADD CONTRACT: ", newData);
    return axios({
        method: "post",
        url: `/api/contracts/dapps/${id}/addcontract`,
        data: newData,
        headers: { "Content-Type": "multipart/form-data" },
    })
        .then(function (response) {
            //handle success
            console.log(response);
        })
        .catch(function (response) {
            //handle error
            console.log(response);
        });
};

const formData = data => {
    let formData = new FormData();
    Object.entries(data).forEach(entry => {
        const key = entry[0];
        const value = entry[1];
        //use key and value here
        formData.append(key, value);
    });
    return formData;
};

export const updateDapp = (id, data) => {
    console.log("calling api updateDapp for ", id, data);
    const newData = formData(data);
    console.log("THIS IS THE FORM DATA: ", newData);
    return axios({
        method: "put",
        url: `/api/dapps/${id}/update`,
        data: newData,
        headers: { "Content-Type": "multipart/form-data" },
    })
        .then(function (response) {
            //handle success
            console.log(response);
            return response;
        })
        .catch(function (response) {
            //handle error
            console.log(response);
            return response;
        });
};

/* --------------------------- UPDATE A DAPP CONTRACT --------------------------- */

export const dappUpdateContract = (id, dappId, contracts) => {
    console.log("calling api dappUpdateContract for: ", id, dappId, contracts);
    return axios({
        method: "put",
        url: `/api/contracts/${id}/update`,
        data: { dappId: dappId, contracts: contracts },
        headers: authHeader(),
    })
        .then(function (response) {
            //handle success
            console.log("THIS IS THE RESPONSE IN APIS DAPP UPDATE CONTRACT : ", response);
            return response;
        })
        .catch(function (response) {
            //handle error
            console.log(response);
        });
};

/* ----------------------------- EVENT SUBSCRIPTION ----------------------------- */

export const registerForSubscriptions = id => {
    console.log("calling api registerForSubscriptions for: ", id);
    return axios.put(`/api/users/${id}/registerforsubscriptions`, {}, { headers: authHeader() }).then(extract);
};

export const cancelSubscriptionRegistration = id => {
    console.log("calling api registerForSubscription for: ", id);
    return axios.put(`/api/users/${id}/cancelsubscriptionregistration`, {}, { headers: authHeader() }).then(extract);
};

export const createSubscription = form => {
    console.log("calling api createSubscription for ", form);
    return axios({
        method: "post",
        url: `/api/users/subscriptions`,
        data: form,
        headers: authHeader(),
    })
        .then(function (response) {
            //handle success
            console.log("THIS IS THE RESPONSE IN APIS: ", response);
            return response;
        })
        .catch(function (response) {
            //handle error
            console.log(response);
        });
};

export const addAwsArn = (id, arn) => {
    console.log("calling api addAwsArn for: ", id, arn);
    return axios({
        method: "put",
        url: `/api/users/subscriptions/${id}/user`,
        data: { arn: arn },
        headers: authHeader(),
    })
        .then(function (response) {
            //handle success
            console.log("THIS IS THE RESPONSE IN APIS ADD AWS ARN: ", response);
            return response;
        })
        .catch(function (response) {
            //handle error
            console.log(response);
        });
};

export const fetchSubscriptions = () => {
    console.log("fetch subscription api called");
    return axios.get(`/api/users/subscriptions`, { headers: authHeader() }).then(extract);
};

export const fetchSubscriptionFilters = query => {
    console.log("calling api fetchSubscriptionFilters for  ", query);
    const response = axios.get(`/api/users/subscriptions/filters?` + query, { headers: authHeader() }).then(extract);
    console.log("RESPONSE IN FETCH SUBSCRIPTION FILTERS", response);
    return response;
};

export const fetchSubscriptionModels = () => {
    console.log("calling api fetchSubscriptionModels");
    const response = axios.get(`/api/users/subscriptions/models`, { headers: authHeader() }).then(extract);
    console.log("RESPONSE IN FETCH SUBSCRIPTION MODELS", response);
    return response;
};

export const postSubscriptionFilters = (form, query) => {
    console.log("calling api postSubscriptionFilters for: ", query);
    return axios.put(`/api/users/subscriptions/filters?` + query, { ...form }, { headers: authHeader() }).then(extract);
};

export const removeFilter = (subscriptionId, filterId) => {
    console.log("calling api removeFilter for: ", subscriptionId, filterId);
    return axios
        .delete(`/api/users/subscriptions/${subscriptionId}/filters/${filterId}`, { headers: authHeader() })
        .then(extract);
};

// ---- uploading an Abi file ---- //

export const uploadAbi = (id, data) => {
    console.log("calling api uploadAbi for ", id, data);
    const newData = formData(data);
    console.log("THIS IS THE FORM DATA IN UPLOAD ABI: ", newData);
    return axios({
        method: "post",
        url: `/api/users/subscriptions/${id}/abis`,
        data: newData,
        headers: { "Content-Type": "multipart/form-data" },
    })
        .then(function (response) {
            //handle success
            console.log("RESPONSE IN API'S, UPLOAD ABI: ", response);
            return response;
        })
        .catch(function (response) {
            //handle error
            console.log(response);
        });
};

// --------------------------------//

export const removeSubscription = subId => {
    return axios.delete(`/api/users/subscriptions/${subId}`, { headers: authHeader() }).then(extract);
};

/* ----------------------------- ANNOUNCEMENTS ----------------------------- */

export const fetchAnnouncements = () => {
    // console.log("IN APIS FETCH ANNOUNCEMENTS")
    return axios.get(`/api/announcements`).then(extract);
};

/* ----------------------------- FETCHING PRICES FROM THE EXCHANGES ----------------------------- */

export const fetchBinance = () => {
    console.log("IN APIS FETCH BINANCE");
    // return axios.get('/api/prices/binance').then(extract);
    return axios.get("/api/prices/binance").then(response => {
        console.log("RESPONSE IN API'S, FETCH BINANCE: ", response);
        return response;
    });
};

export const fetchOkex = () => {
    console.log("IN APIS FETCH OKEX");
    return axios.get("/api/prices/okex").then(extract);
};

export const fetchBittrex = () => {
    console.log("IN APIS FETCH BITTREX");
    return axios.get("/api/prices/bittrex").then(extract);
};

/* ----------------------------- CAPTURING LAST LOGIN ----------------------------- */

export const captureLastLogin = (id, time) => {
    console.log("IN CAPTURE LOGIN APIS: ", id, time);
    return axios({
        method: "put",
        url: `/api/users/time/${id}`,
        data: { time: time },
        // headers: authHeader()
    });
    // .then(function (response) {
    // 	//handle success
    // 	console.log("THIS IS THE RESPONSE IN APIS CAPTURE LAST LOGIN : ", response);
    // 	return response
    // })
    // .catch(function (response) {
    // 	//handle error
    // 	console.log(response);
    // })
};

/* ----------------------------- CAPTURING LAST LOGIN ----------------------------- */

export const fetchDroppPricing = () => {
    return axios.get("/api/dropp/pricing", { headers: authHeader() }).then(extract);
};

const topics = {
    size: 3,
    totalCount: 3,
    data: [
        {
            topicID: "0.0.4444",
            memo: "Test Memo",
            createdDate: "2020-03-30T16:33:30.501+0000",
            createdBy: "0.0.1111",
            transactionID: "XXXXXXXXXXXXXXXXXXXXXX",
            readableTransactionID: "0.0.accountNum@XXXXXXXXX-XXXXXX",
        },
        {
            topicID: "0.0.5555",
            memo: "Test Memo",
            createdDate: "2020-03-30T16:33:30.501+0000",
            createdBy: "0.0.2222",
            transactionID: "XXXXXXXXXXXXXXXXXXXXXX",
            readableTransactionID: "0.0.accountNum@XXXXXXXXX-XXXXXX",
        },
        {
            topicID: "0.0.6666",
            memo: "Test Memo",
            createdDate: "2020-03-30T16:33:30.501+0000",
            createdBy: "0.0.3333",
            transactionID: "XXXXXXXXXXXXXXXXXXXXXX",
            readableTransactionID: "0.0.accountNum@XXXXXXXXX-XXXXXX",
        },
    ],
};

const transactionParams = {
    to: "0.0.77832",
    from: "0.0.131340",
    amount: "49,420",
};

const dappTransfers = {
    size: 50,
    totalCount: 113,
    data: [
        {
            index: 1,
            contractID: "0.0.77832",
            calledBy: "0.0.17210",
            contractMethodName: "e59aee0c",
            functionParameters:
                "e59aee0c000000000000000000000000000000000000000000000000000000000001ef120000000000000000000000000000000000000000000000000000000000000453",
            consensusTime: "2019-11-08T04:28:14.467+0000",
            transactionID: "00172101573187283904448000",
            logContractID: "0.0.77832",
            bloom:
                "00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000010000000000000000000000000000000000000000000000008000000000000000000000000000000000000000040000000020000000000000000000800000000000800000000000010000000000000000000000000000000000000000010000000000000000000000000000000000000000000000200000000000000000000000000000000000000100000000000000002000100000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000010000000000000001000000",
            data: "",
            topic1: "ddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef",
            topic2: "0000000000000000000000000000000000000000000000000000000000000000",
            topic3: "000000000000000000000000000000000000000000000000000000000001ef12",
            topic4: "0000000000000000000000000000000000000000000000000000000000000082",
            decodedFunctionParameters: {
                method: "registerDomain",
                types: ["string", "uint256", "string"],
                inputs: ["alamo", "2", "0.0.11611"],
                names: ["name", "_type", "id"],
            },
        },
        {
            index: 1,
            contractID: "0.0.77832",
            calledBy: "0.0.17210",
            contractMethodName: "e59aee0c",
            functionParameters:
                "e59aee0c000000000000000000000000000000000000000000000000000000000001bcb700000000000000000000000000000000000000000000000000000000000004d2",
            consensusTime: "2019-10-17T14:59:06.331+0000",
            transactionID: "00172101571324334671000000",
            logContractID: "0.0.77832",
            bloom:
                "00000000000000000000000000000000000000000000000000000000000000001000000000000000000000000000000000000000000000000000000000000000000000000000000000000008000000000000000000000000000000000000000000000000020000000000000000100800000000000000000000000010000000000000000000001000000000000000000010000000000000000000000000000000000000000000000200000000000000000000000000000000000000000000000000000002000000000000000000000000000000000000200000000000000020000000000000000000000001000000000000000000000000000000000001040000",
            data: "",
            topic1: "ddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef",
            topic2: "0000000000000000000000000000000000000000000000000000000000000000",
            topic3: "000000000000000000000000000000000000000000000000000000000001bcb7",
            topic4: "0000000000000000000000000000000000000000000000000000000000000081",
            decodedFunctionParameters: {
                method: "registerDomain",
                types: ["string", "uint256", "string"],
                inputs: ["alamo", "2", "0.0.11611"],
                names: ["name", "_type", "id"],
            },
        },
    ],
};

const dappTransactions = {
    size: 5,
    totalCount: 6984414,
    data: [
        {
            id: "0021572968155447785000-SUCCESS",
            transactionID: "0021572968155447785000",
            transactionHash:
                "dfaeff32e6c58700f923e93e59202c4754593cd97d977f10d2ccf74c7ccfd7f6229625f96303d1956f1c3f1e9201eae2",
            payerID: "0.0.2",
            startTime: "2019-11-05T15:35:55.447+0000",
            startTimeEpochSecs: 1572968155,
            startTimeNanos: 447785000,
            nodeID: "0.0.3",
            consensusTime: "2019-11-05T15:36:05.473+0000",
            transactionFee: 279922,
            nodeFees: 16912,
            networkFees: 263010,
            transfers: [
                { accountID: "0.0.2", amount: -277152 },
                { accountID: "0.0.3", amount: 16911 },
                { accountID: "0.0.98", amount: 260241 },
                { accountID: "0.0.2", amount: -2770 },
                { accountID: "0.0.98", amount: 2770 },
                { accountID: "0.0.3", amount: 1 },
                { accountID: "0.0.2", amount: -1 },
            ],
            status: "SUCCESS",
            amount: 279923,
            memo: "Network ping",
            createdID: "N/A",
            logInfo: null,
            transactionType: "CRYPTO_TRANSFER",
            knownLabel: "CryptoTransfer",
            typeLabel: "Crypto Transfer",
            fileID: "N/A",
            contractID: "N/A",
            serviceType: "CRYPTO",
            functionParameters: "N/A",
        },
        {
            id: "0021572968145443970000-SUCCESS",
            transactionID: "0021572968145443970000",
            transactionHash:
                "42557c38b775ff3738f35e04296c65b768025a8cbdd808c5e7da8076cd6bb102a25e0dd183960217ce19c098676fccf0",
            payerID: "0.0.2",
            startTime: "2019-11-05T15:35:45.443+0000",
            startTimeEpochSecs: 1572968145,
            startTimeNanos: 443970000,
            nodeID: "0.0.3",
            consensusTime: "2019-11-05T15:35:55.491+0000",
            transactionFee: 279922,
            nodeFees: 16912,
            networkFees: 263010,
            transfers: [
                { accountID: "0.0.2", amount: -277152 },
                { accountID: "0.0.3", amount: 16911 },
                { accountID: "0.0.98", amount: 260241 },
                { accountID: "0.0.2", amount: -2770 },
                { accountID: "0.0.98", amount: 2770 },
                { accountID: "0.0.3", amount: 1 },
                { accountID: "0.0.2", amount: -1 },
            ],
            status: "SUCCESS",
            amount: 279923,
            memo: "Network ping",
            createdID: "N/A",
            logInfo: null,
            transactionType: "CRYPTO_TRANSFER",
            knownLabel: "CryptoTransfer",
            typeLabel: "Crypto Transfer",
            fileID: "N/A",
            contractID: "N/A",
            serviceType: "CRYPTO",
            functionParameters: "N/A",
        },
        {
            id: "001119157296813878818800-SUCCESS",
            transactionID: "001119157296813878818800",
            transactionHash:
                "599b37b9d6b39812283620f2f87e5d3ed9a8124bab48cf36e1bf307f97a4f36e2ed544811c97510d330dfe652a31193d",
            payerID: "0.0.1119",
            startTime: "2019-11-05T15:35:38.078+0000",
            startTimeEpochSecs: 1572968138,
            startTimeNanos: 78818800,
            nodeID: "0.0.3",
            consensusTime: "2019-11-05T15:35:48.875+0000",
            transactionFee: 279082,
            nodeFees: 1932549,
            networkFees: -1653467,
            transfers: [
                { accountID: "0.0.1119", amount: -276312 },
                { accountID: "0.0.3", amount: 16851 },
                { accountID: "0.0.98", amount: 259461 },
                { accountID: "0.0.1119", amount: -2770 },
                { accountID: "0.0.98", amount: 2770 },
                { accountID: "0.0.1119", amount: -1915698 },
                { accountID: "0.0.3", amount: 1915698 },
            ],
            status: "SUCCESS",
            amount: 2194780,
            memo: "",
            createdID: "N/A",
            logInfo: null,
            transactionType: "CRYPTO_TRANSFER",
            knownLabel: "CryptoTransfer",
            typeLabel: "Crypto Transfer",
            fileID: "N/A",
            contractID: "N/A",
            serviceType: "CRYPTO",
            functionParameters: "N/A",
        },
        {
            id: "0011191572968137974215600-SUCCESS",
            transactionID: "0011191572968137974215600",
            transactionHash:
                "25add14c13cfd5383f8253b4527ee7646e7d63c5eb4542124009336bd99fccdac6eb3a13541f1f592e34ad3d1c646a6a",
            payerID: "0.0.1119",
            startTime: "2019-11-05T15:35:37.974+0000",
            startTimeEpochSecs: 1572968137,
            startTimeNanos: 974215600,
            nodeID: "0.0.3",
            consensusTime: "2019-11-05T15:35:48.773+0000",
            transactionFee: 279082,
            nodeFees: 1932549,
            networkFees: -1653467,
            transfers: [
                { accountID: "0.0.1119", amount: -276312 },
                { accountID: "0.0.3", amount: 16851 },
                { accountID: "0.0.98", amount: 259461 },
                { accountID: "0.0.1119", amount: -2770 },
                { accountID: "0.0.98", amount: 2770 },
                { accountID: "0.0.1119", amount: -1915698 },
                { accountID: "0.0.3", amount: 1915698 },
            ],
            status: "SUCCESS",
            amount: 2194780,
            memo: "",
            createdID: "N/A",
            logInfo: null,
            transactionType: "CRYPTO_TRANSFER",
            knownLabel: "CryptoTransfer",
            typeLabel: "Crypto Transfer",
            fileID: "N/A",
            contractID: "N/A",
            serviceType: "CRYPTO",
            functionParameters: "N/A",
        },
        {
            id: "0011191572968137882815600-SUCCESS",
            transactionID: "0011191572968137882815600",
            transactionHash:
                "12ebb8b0aa2306eff20c831d03733e0d2afb6b5df7b13c7bf6a2a1a4e345f8553af7e00be534e854c35688e079bab82c",
            payerID: "0.0.1119",
            startTime: "2019-11-05T15:35:37.882+0000",
            startTimeEpochSecs: 1572968137,
            startTimeNanos: 882815600,
            nodeID: "0.0.3",
            consensusTime: "2019-11-05T15:35:48.684+0000",
            transactionFee: 279082,
            nodeFees: 1932549,
            networkFees: -1653467,
            transfers: [
                { accountID: "0.0.1119", amount: -276312 },
                { accountID: "0.0.3", amount: 16851 },
                { accountID: "0.0.98", amount: 259461 },
                { accountID: "0.0.1119", amount: -2770 },
                { accountID: "0.0.98", amount: 2770 },
                { accountID: "0.0.1119", amount: -1915698 },
                { accountID: "0.0.3", amount: 1915698 },
            ],
            status: "SUCCESS",
            amount: 2194780,
            memo: "",
            createdID: "N/A",
            logInfo: null,
            transactionType: "CRYPTO_TRANSFER",
            knownLabel: "CryptoTransfer",
            typeLabel: "Crypto Transfer",
            fileID: "N/A",
            contractID: "N/A",
            serviceType: "CRYPTO",
            functionParameters: "N/A",
        },
    ],
};

const dapp = {
    id: 1,
    title: "MedCore",
    description: "Enables fund raising for medical research",
    website: "www.medcore.io",
    numTransactions: 715,
    numAccounts: 59,
    activeSince: "Nov, 2019",
    accountId: "0.0.1098",
    androidAppLink: "https://play.google.com/store/apps/medcore",
    iosAppLink: "https://apps.apple.com/us/app/medcore",
};

const dapps = [
    {
        id: 1,
        name: "MedCore",
        description: "Enables fund raising for medical research",
        website: "www.medcore.io",
        numTransactions: 715,
        numAccounts: 59,
        activeSince: "Nov, 2019",
    },
    {
        id: 2,
        name: "SweatTrack",
        description: "Promotes a healthy lifestyle by recording and rewarding gym visits and other physical activity",
        website: "www.sweattrack.de",
        numTransactions: 23106,
        numAccounts: 59,
        activeSince: "Nov, 2019",
    },
];

const apiKeyPair = {
    key: "cfb1f324d71f488030b18aa867453e357bee54fa",
    accessKey: "a3f7129e-07f8-3a94-8f35-36d31ffac70b",
    state: "ACTIVE",
};

const apiCategories = [
    {
        id: "0",
        title: "Introduction",
        description: "",
    },
    {
        id: "1",
        title: "Accounts",
        description: "",
    },
    {
        id: "2",
        title: "Contracts",
        description: "",
    },
    {
        id: "3",
        title: "Nodes",
        description: "",
    },
    {
        id: "4",
        title: "Search",
        description: "",
    },
    {
        id: "5",
        title: "Transactions",
        description: "",
    },
];

const apiList = [
    // ACCOUNTS:
    {
        id: "1",
        title: "Search",
        description: "",
        url: "/api/accounts",
        categoryId: "1",
    },
    {
        id: "2",
        title: "Get Balances",
        description: "",
        url: "/api/accounts/{accountID}/balances/{asOfInEpoch}",
        categoryId: "1",
    },
    {
        id: "3",
        title: "Get Balances",
        description: "",
        url: "/api/accounts/{accountID}/balances/latest",
        categoryId: "1",
    },
    {
        id: "4",
        title: "Get File Ids For Account",
        description: "",
        url: "/api/accounts/{accountID}/files",
        categoryId: "1",
    },
    {
        id: "5",
        title: "Get Balance History",
        description: "",
        url: "/api/accounts/{accountID}/intervalBalances",
        categoryId: "1",
    },
    {
        id: "6",
        title: "Get Account Transactions",
        description: "",
        url: "/api/accounts/{accountID}/transactions",
        categoryId: "1",
    },
    {
        id: "7",
        title: "Get Account Transfers",
        description: "",
        url: "/api/accounts/{accountID}/transfers",
        categoryId: "1",
    },
    {
        id: "8",
        title: "Get Active Accounts",
        description: "",
        url: "/api/accounts/active",
        categoryId: "1",
    },
    {
        id: "9",
        title: "Get Count Of Accounts Created",
        description: "",
        url: "/api/accounts/counts",
        categoryId: "1",
    },
    // CONTRACTS:
    {
        id: "10",
        title: "Search",
        description: "",
        url: "/api/contracts",
        categoryId: "2",
    },
    {
        id: "11",
        title: "Get Balances",
        description: "",
        url: "/api/contracts/{contractID}/balances",
        categoryId: "2",
    },
    {
        id: "12",
        title: "Get Balances",
        description: "",
        url: "/api/contracts/{contractID}/balances/{asOfInEpoch}",
        categoryId: "2",
    },
    {
        id: "13",
        title: "Get Contract Call",
        description: "",
        url: "/api/contracts/{contractID}/callCount",
        categoryId: "2",
    },
    {
        id: "14",
        title: "Get Balance History",
        description: "",
        url: "/api/contracts/{contractID}/intervalBalances",
        categoryId: "2",
    },
    {
        id: "15",
        title: "Get Contract Transfers",
        description: "",
        url: "/api/contracts/{contractID}/transfers",
        categoryId: "2",
    },
    // NODES:
    {
        id: "16",
        title: "Get Node Analytics",
        description: "",
        url: "/api/nodes/{nodeID}/analytics",
        categoryId: "3",
    },
    {
        id: "17",
        title: "Get Node Analytics",
        description: "",
        url: "/api/nodes/analytics",
        categoryId: "3",
    },
    // SEARCH:
    {
        id: "18",
        title: "Search Account",
        description: "",
        url: "/api/accounts/search",
        categoryId: "4",
    },
    {
        id: "19",
        title: "Get Latest Hbar Price",
        description: "",
        url: "/api/hbars/price",
        categoryId: "4",
    },
    {
        id: "20",
        title: "Search Payments",
        description: "",
        url: "/api/payments/search",
        categoryId: "4",
    },
    //TRANSACTIONS:
    {
        id: "21",
        title: "Search",
        description: "",
        url: "/api/transactions",
        categoryId: "5",
    },
    {
        id: "22",
        title: "Find By ID",
        description: "",
        url: "/api/transactions/{transactionID}",
        categoryId: "5",
    },
    {
        id: "23",
        title: "Get Total Count",
        description: "",
        url: "/api/transactions/counts",
        categoryId: "5",
    },
    {
        id: "24",
        title: "Get Transaction Count",
        description: "",
        url: "/api/transactions/intervalCounts",
        categoryId: "5",
    },
    {
        id: "25",
        title: "Get Transaction Value",
        description: "",
        url: "/api/transactions/intervalValues",
        categoryId: "5",
    },
    {
        id: "26",
        title: "Get Transaction Volume",
        description: "",
        url: "/api/transactions/intervalVolumes",
        categoryId: "5",
    },
    {
        id: "27",
        title: "Get Raw Transaction",
        description: "",
        url: "/api/transactions/raw",
        categoryId: "5",
    },
    {
        id: "28",
        title: "Get Transaction Count Group By Service",
        description: "",
        url: "/api/transactions/services/counts",
        categoryId: "5",
    },
];

/*
export const doAdvancedSearch = ({
	q,
	accountFrom,
	accountTo,
	startDate,
	endDate,
	amountFrom,
	amountTo,
	query = ''
}) => {
	if (q && q.trim()) query += `&q=${q.trim()}`;

	if (accountFrom && accountFrom.trim()) query += `&accountFrom=${accountFrom.trim()}`;
	if (accountTo && accountTo.trim()) query += `&accountTo=${accountTo.trim()}`;

	if (startDate && startDate.trim()) query += `&consensusStartInEpoch=${toEpoch(startDate.trim())}`;
	if (endDate && endDate.trim()) query += `&consensusEndInEpoch=${toEpoch(endDate.trim())}`;

	if (amountFrom && amountFrom.trim()) query += `&amountFrom=${amountFrom.trim()}`;
	if (amountTo && amountTo.trim()) query += `&amountTo=${amountTo.trim()}`;

	//	const query = `accountFrom=0.0.2&accountTo=0.0.98`;
	return axios.get(`/api/transactions?${query}`).then(extract);
};


const files = [
	{
		id: 'F1',
		expiry: '2/2/2020'
	},
	{
		id: 'F2',
		expiry: '8/15/2022'
	}
];

const news = [
	{
		id: 1,
		title: 'Ugh finally, Samsung adds support for Bitcoin in Blockchain KeyStore',
		url: 'https://thenextweb.com/hardfork/2019/08/14/samsung-adds-support-bitcoin-blockchain-keystore/',
		source: 'Yahoo Finance',
		date: '23 June 2019'
	},
	{
		id: 2,
		title: 'BlockFi, which lends money to cryptocurrency holders, just raised $18.3 million led by Valar Ventures',
		url:
			'http://techcrunch.com/2019/08/06/blockfi-which-lends-money-to-cryptocurrency-holders-just-raised-18-3-million-led-by-valar-ventures/',
		source: 'Tech Crunch',
		date: '9 May 2019'
	}
];



const stats = {
	numAccounts: 1233,
	numTransactions: 41323213
};

const priceTrend = [
	{ time: 1565539200, value: 0.12 },
	{ time: 1565542800, value: 0.13 },
	{ time: 1565546400, value: 0.14 },
	{ time: 1565550000, value: 0.15 },
	{ time: 1565553600, value: 0.132 },
	{ time: 1565557200, value: 0.133 },
	{ time: 1565560800, value: 0.132 },
	{ time: 1565564400, value: 0.131 },
	{ time: 1565568000, value: 0.12 },
	{ time: 1565571600, value: 0.125 },
	{ time: 1565571600, value: 0.129 },
	{ time: 1565571600, value: 0.13 },
	{ time: 1565571600, value: 0.15 },
	{ time: 1565571600, value: 0.16 },
	{ time: 1565571600, value: 0.2 },
	{ time: 1565571600, value: 0.22 },
	{ time: 1565571600, value: 0.23 },
	{ time: 1565571600, value: 0.35 },
	{ time: 1565571600, value: 0.33 }
];

const balanceHistory = {
	currentBalance: '13213213.212',
	pctChange: 2.7,
	trend: [
		{ time: 1565539200, value: 0.12 },
		{ time: 1565542800, value: 0.13 },
		{ time: 1565546400, value: 0.14 },
		{ time: 1565550000, value: 0.15 },
		{ time: 1565553600, value: 0.132 },
		{ time: 1565557200, value: 0.133 },
		{ time: 1565560800, value: 0.132 },
		{ time: 1565564400, value: 0.131 },
		{ time: 1565568000, value: 0.12 },
		{ time: 1565571600, value: 0.125 },
		{ time: 1565571600, value: 0.129 },
		{ time: 1565571600, value: 0.13 },
		{ time: 1565571600, value: 0.15 },
		{ time: 1565571600, value: 0.16 },
		{ time: 1565571600, value: 0.2 },
		{ time: 1565571600, value: 0.22 },
		{ time: 1565571600, value: 0.23 },
		{ time: 1565571600, value: 0.35 },
		{ time: 1565571600, value: 0.33 }
	]
};

const nodes = [
	{
		id: '1',
		name: 'Swirlds',
		latitude: 31.96,
		longitude: -99.9,
		txnCount: 29219,
		hbarEarned: 756503
	},
	{
		id: '2',
		name: 'Swisscom',
		latitude: 46.81,
		longitude: 8.22,
		txnCount: 23182,
		hbarEarned: 591503
	},
	{
		id: '3',
		name: 'Nomura',
		latitude: 36.2,
		longitude: 138.25,
		txnCount: 11212,
		hbarEarned: 312121
	}
];

const nodesData = [
	{
		id: '1',
		name: 'Swirlds',
		location: {
			lat: 31.96,
			lng: 99.9
		},
		txnCount: 23182,
		hbarEarned: 591503
	},
	{
		id: '2',
		name: 'Swisscom',
		location: {
			lat: 46.81,
			lng: 8.22
		},
		txnCount: 29219,
		hbarEarned: 756503
	},
	{
		id: '3',
		name: 'Nomura',
		location: {
			lat: 36.2,
			lng: 138.25
		},
		txnCount: 11212,
		hbarEarned: 312121
	}
];

const account = {
	id: '0.0.1234',
	publicKey: 'N/A',
	expiryDate: 'N/A',
	memo: 'No memo added',
	balance: '13213213.212',
	numRecentTxns: 0
};

const transfers = [
	{
		id: '1',
		type: 'credit',
		date: '9/15/2109',
		from: '0.0.4131',
		amount: '21321.22',
		memo: 'n/a'
	},
	{
		id: '2',
		type: 'debit',
		date: '9/7/2109',
		to: '0.0.9834',
		amount: '8397.10',
		memo: 'Invoice 3991AZ'
	},
	{
		id: '3',
		type: 'credit',
		date: '9/6/2109',
		from: '0.0.4131 | 0.0.938',
		amount: '21321.22',
		memo: 'Purchase from XYZ Exchange'
	}
];

const transactions = [
	{
		id: '1',
		type: 'Transfer',
		date: '9/15/2109',
		account: '0.0.8438',
		fee: '0.0032',
		amount: '4.000',
		memo: 'n/a'
	},
	{
		id: '2',
		type: 'Contract Call',
		date: '9/14/2109',
		account: '0.0.3620',
		fee: '0.0001',
		amount: '0.0000',
		memo: 'n/a'
	},
	{
		id: '3',
		type: 'Account Update',
		date: '9/14/2109',
		account: '0.0.2092',
		fee: '0.0001',
		amount: '0.0050',
		memo: 'n/a'
	}
];

const searchResult = {
	account: {
		name: 'account',
		results: [
			{
				title: '0.0.2',
				type: 'account'
			},
			{
				title: '0.0.3',
				type: 'account'
			},
			{
				title: '0.0.4',
				type: 'account'
			},
			{
				title: '0.0.5',
				type: 'account'
			},
			{
				title: '0.0.6',
				type: 'account'
			}
		]
	},
	transaction: {
		name: 'transaction',
		results: [
			{
				title: '0021565797722775282000',
				type: 'transaction'
			},
			{
				title: '0021565797723798303000',
				type: 'transaction'
			}
		]
	}
};
*/

/*
export const contracts = {"size":25,"totalCount":3120,"data":[{"contractID":"0.0.51339","payerID":"0.0.1207","constructorParameter":"00000000000000000000000000000000000000000000000000000000000059480000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001c000000000000000000000000000000000000000000000000000000000000f424000000000000000000000000000000000000000000000000000000000000f424000000000000000000000000000000000000000000000000000000000000f42400000000000000000000000000000000000000000000000000000000000000064000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000002000000000000000000000000000000000000000000000000000000000000000240000000000000000000000000000000000000000000000000000000005d674604000000000000000000000000000000000000000000000000000000005d689784000000000000000000000000000000000000000000000000000000000000c3ba00000000000000000000000000000000000000000000000000000000000000013200000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000550313131310000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000007416c676572696100000000000000000000000000000000000000000000000000","fileID":"0.0.51338","expiry":"2019-08-29T04:27:10.356+0000","autoRenew":3600,"memo":"","createdOn":"2019-08-29T03:27:10.356+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"bdcc4635a3c13aa33e8ceb53295ebc117396031747c26921d131139ae8f43c87","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51341","payerID":"0.0.1207","constructorParameter":"00000000000000000000000000000000000000000000000000000000000059480000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001c000000000000000000000000000000000000000000000000000000000000f424000000000000000000000000000000000000000000000000000000000000f424000000000000000000000000000000000000000000000000000000000000f42400000000000000000000000000000000000000000000000000000000000000064000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000002000000000000000000000000000000000000000000000000000000000000000240000000000000000000000000000000000000000000000000000000005d674639000000000000000000000000000000000000000000000000000000005d6897b9000000000000000000000000000000000000000000000000000000000000c3ba00000000000000000000000000000000000000000000000000000000000000013200000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000450313233000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000007416c676572696100000000000000000000000000000000000000000000000000","fileID":"0.0.51340","expiry":"2019-08-29T04:28:03.400+0000","autoRenew":3600,"memo":"","createdOn":"2019-08-29T03:28:03.400+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"bdcc4635a3c13aa33e8ceb53295ebc117396031747c26921d131139ae8f43c87","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51343","payerID":"0.0.1207","constructorParameter":"00000000000000000000000000000000000000000000000000000000000059480000000000000000000000000000000000000000000000000000000000005948000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001c000000000000000000000000000000000000000000000000000000000000f462800000000000000000000000000000000000000000000000000000000000f424000000000000000000000000000000000000000000000000000000000000f42400000000000000000000000000000000000000000000000000000000000000078000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000002000000000000000000000000000000000000000000000000000000000000000240000000000000000000000000000000000000000000000000000000005d6746a8000000000000000000000000000000000000000000000000000000005d689828000000000000000000000000000000000000000000000000000000000000c3ba0000000000000000000000000000000000000000000000000000000000000009302e302e32323835360000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000550313131310000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000007416c676572696100000000000000000000000000000000000000000000000000","fileID":"0.0.51342","expiry":"2019-08-29T04:29:54.431+0000","autoRenew":3600,"memo":"","createdOn":"2019-08-29T03:29:54.431+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"bdcc4635a3c13aa33e8ceb53295ebc117396031747c26921d131139ae8f43c87","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51362","payerID":"0.0.38219","constructorParameter":"0000000000000000000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000000000000000000000001268656c6c6f2066726f6d20686564657261210000000000000000000000000000","fileID":"0.0.51361","expiry":"2019-08-29T11:27:27.734+0000","autoRenew":3600,"memo":"","createdOn":"2019-08-29T10:27:27.734+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51364","payerID":"0.0.38219","constructorParameter":"0000000000000000000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000000000000000000000001268656c6c6f2066726f6d20686564657261210000000000000000000000000000","fileID":"0.0.51363","expiry":"2019-08-29T11:27:58.046+0000","autoRenew":3600,"memo":"","createdOn":"2019-08-29T10:27:58.046+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51366","payerID":"0.0.38219","constructorParameter":"0000000000000000000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000000000000000000000001268656c6c6f2066726f6d20686564657261210000000000000000000000000000","fileID":"0.0.51365","expiry":"2019-08-29T11:32:44.148+0000","autoRenew":3600,"memo":"","createdOn":"2019-08-29T10:32:44.148+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51368","payerID":"0.0.38219","constructorParameter":"0000000000000000000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000000000000000000000001268656c6c6f2066726f6d20686564657261210000000000000000000000000000","fileID":"0.0.51367","expiry":"2019-08-29T11:34:03.340+0000","autoRenew":3600,"memo":"","createdOn":"2019-08-29T10:34:03.340+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51370","payerID":"0.0.38219","constructorParameter":"0000000000000000000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000000000000000000000001268656c6c6f2066726f6d20686564657261210000000000000000000000000000","fileID":"0.0.51369","expiry":"2019-08-29T11:36:55.416+0000","autoRenew":3600,"memo":"","createdOn":"2019-08-29T10:36:55.416+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51372","payerID":"0.0.38219","constructorParameter":"0000000000000000000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000000000000000000000001268656c6c6f2066726f6d20686564657261210000000000000000000000000000","fileID":"0.0.51371","expiry":"2019-08-29T11:38:34.812+0000","autoRenew":3600,"memo":"","createdOn":"2019-08-29T10:38:34.812+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51374","payerID":"0.0.38219","constructorParameter":"0000000000000000000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000000000000000000000001268656c6c6f2066726f6d20686564657261210000000000000000000000000000","fileID":"0.0.51373","expiry":"2019-08-29T11:43:57.264+0000","autoRenew":3600,"memo":"","createdOn":"2019-08-29T10:43:57.264+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51376","payerID":"0.0.38219","constructorParameter":"0000000000000000000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000000000000000000000001268656c6c6f2066726f6d20686564657261210000000000000000000000000000","fileID":"0.0.51375","expiry":"2019-08-29T11:49:20.903+0000","autoRenew":3600,"memo":"","createdOn":"2019-08-29T10:49:20.903+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51390","payerID":"0.0.17210","constructorParameter":"","fileID":"0.0.51389","expiry":"2019-08-29T22:20:59.777+0000","autoRenew":25598,"memo":"","createdOn":"2019-08-29T15:14:21.777+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51392","payerID":"0.0.17210","constructorParameter":"","fileID":"0.0.51391","expiry":"2019-08-29T22:24:07.599+0000","autoRenew":25598,"memo":"","createdOn":"2019-08-29T15:17:29.599+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51401","payerID":"0.0.1301","constructorParameter":"","fileID":"0.0.51400","expiry":"2019-09-01T16:30:01.916+0000","autoRenew":259200,"memo":"Greeting Contract Create: Instantiating Contract Instance $Ih#F4cQaz","createdOn":"2019-08-29T16:30:01.916+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"faa1e28c1e6b605b2b40d5a1360a9009006b94b950afd94546dae93c903fd0f6","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51453","payerID":"0.0.1301","constructorParameter":"","fileID":"0.0.51452","expiry":"2019-09-02T16:31:00.873+0000","autoRenew":345600,"memo":"Greeting Contract Create: Instantiating Contract Instance L-NJ1!H$7n","createdOn":"2019-08-29T16:31:00.873+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"faa1e28c1e6b605b2b40d5a1360a9009006b94b950afd94546dae93c903fd0f6","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51455","payerID":"0.0.1301","constructorParameter":"0000000000000000000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000000000000000000000002a48656c6c6f2066726f6d202e4e45542e2054687572736461792c204175677573742032392c203230313900000000000000000000000000000000000000000000","fileID":"0.0.51454","expiry":"2019-08-31T16:31:02.661+0000","autoRenew":172800,"memo":"Stateful Contract Create: Instantiating Stateful Instance t#brl6ooPS","createdOn":"2019-08-29T16:31:02.661+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"faa1e28c1e6b605b2b40d5a1360a9009006b94b950afd94546dae93c903fd0f6","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51457","payerID":"0.0.1301","constructorParameter":"0000000000000000000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000000000000000000000002a48656c6c6f2066726f6d202e4e45542e2054687572736461792c204175677573742032392c203230313900000000000000000000000000000000000000000000","fileID":"0.0.51456","expiry":"2019-08-31T16:31:04.496+0000","autoRenew":172800,"memo":"Stateful Contract Create: Instantiating Stateful Instance mkv*h!FqbD","createdOn":"2019-08-29T16:31:04.496+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"faa1e28c1e6b605b2b40d5a1360a9009006b94b950afd94546dae93c903fd0f6","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51459","payerID":"0.0.1301","constructorParameter":"0000000000000000000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000000000000000000000002a48656c6c6f2066726f6d202e4e45542e2054687572736461792c204175677573742032392c203230313900000000000000000000000000000000000000000000","fileID":"0.0.51458","expiry":"2019-09-01T16:31:07.234+0000","autoRenew":259200,"memo":"Stateful Contract Create: Instantiating Stateful Instance KHqIPclReq","createdOn":"2019-08-29T16:31:07.234+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"faa1e28c1e6b605b2b40d5a1360a9009006b94b950afd94546dae93c903fd0f6","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51462","payerID":"0.0.1301","constructorParameter":"","fileID":"0.0.51461","expiry":"2019-09-01T16:31:09.674+0000","autoRenew":259200,"memo":"Greeting Contract Create: Instantiating Contract Instance hxkh1%#a2j","createdOn":"2019-08-29T16:31:09.674+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"faa1e28c1e6b605b2b40d5a1360a9009006b94b950afd94546dae93c903fd0f6","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51468","payerID":"0.0.1301","constructorParameter":"","fileID":"0.0.51467","expiry":"2019-09-02T16:31:14.575+0000","autoRenew":345600,"memo":"Payable Contract Create: Instantiating Payable Instance BLmyULsOrJ","createdOn":"2019-08-29T16:31:14.575+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"faa1e28c1e6b605b2b40d5a1360a9009006b94b950afd94546dae93c903fd0f6","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51470","payerID":"0.0.1301","constructorParameter":"","fileID":"0.0.51469","expiry":"2019-08-31T16:31:16.042+0000","autoRenew":172800,"memo":"Event Emit Contract Create: Instantiating Event Emit Instance G8bsIrAToo","createdOn":"2019-08-29T16:31:16.042+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"faa1e28c1e6b605b2b40d5a1360a9009006b94b950afd94546dae93c903fd0f6","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51472","payerID":"0.0.1301","constructorParameter":"0000000000000000000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000000000000000000000002a48656c6c6f2066726f6d202e4e45542e2054687572736461792c204175677573742032392c203230313900000000000000000000000000000000000000000000","fileID":"0.0.51471","expiry":"2019-09-01T16:31:17.526+0000","autoRenew":259200,"memo":"Stateful Contract Create: Instantiating Stateful Instance eTp&CjKCNQ","createdOn":"2019-08-29T16:31:17.526+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"faa1e28c1e6b605b2b40d5a1360a9009006b94b950afd94546dae93c903fd0f6","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51476","payerID":"0.0.1301","constructorParameter":"0000000000000000000000000000000000000000000000000000000000000020000000000000000000000000000000000000000000000000000000000000002a48656c6c6f2066726f6d202e4e45542e2054687572736461792c204175677573742032392c203230313900000000000000000000000000000000000000000000","fileID":"0.0.51475","expiry":"2019-09-01T16:31:20.428+0000","autoRenew":259200,"memo":"Stateful Contract Create: Instantiating Stateful Instance vmm@-3pVLZ","createdOn":"2019-08-29T16:31:20.428+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"faa1e28c1e6b605b2b40d5a1360a9009006b94b950afd94546dae93c903fd0f6","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51491","payerID":"0.0.1301","constructorParameter":"","fileID":"0.0.51490","expiry":"2019-09-01T16:31:30.412+0000","autoRenew":259200,"memo":"Payable Contract Create: Instantiating Payable Instance Y55pMGhVAG","createdOn":"2019-08-29T16:31:30.412+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"faa1e28c1e6b605b2b40d5a1360a9009006b94b950afd94546dae93c903fd0f6","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}},{"contractID":"0.0.51495","payerID":"0.0.1301","constructorParameter":"","fileID":"0.0.51494","expiry":"2019-09-02T16:31:33.668+0000","autoRenew":345600,"memo":"Greeting Contract Create: Instantiating Contract Instance %Q3zA5To1L","createdOn":"2019-08-29T16:31:33.668+0000","lastUpdatedOn":null,"obtainerID":null,"adminKey":{"contractID":"0.0.0","ed25519":"faa1e28c1e6b605b2b40d5a1360a9009006b94b950afd94546dae93c903fd0f6","RSA_3072":"","ECDSA_384":"","thresholdKey":null,"keys":null,"rsa_3072":"","ecdsa_384":""}}],"facets":{"payerID":{"0.0.1003":198,"0.0.1301":462,"0.0.1004":187,"0.0.1002":206,"0.0.1010":198,"0.0.1011":220,"0.0.1009":195,"0.0.1008":235,"0.0.1005":208,"0.0.1006":193},"contractID":{"0.0.10008":1,"0.0.10018":1,"0.0.10009":1,"0.0.10017":1,"0.0.10002":1,"0.0.10013":1,"0.0.10024":1,"0.0.10001":1,"0.0.10012":1,"0.0.10020":1}}}
*/

export const fetchProfileBalance = params => {
    params["currentBalance"] = params["currentBalance"] || false;
    let requestUrl =
        "/api/users/" +
        params.userId +
        "/profileBalance?email=" +
        params.email +
        "&merchantId=" +
        params.merchantId +
        "&currentBalance=" +
        params.currentBalance;
    return axios.get(requestUrl, { headers: authHeader() }).then(extract);
};

export const fetchUserInvoices = params => {
    let requestUrl =
        "/api/users/" +
        params.userId +
        "/getInvoices?email=" +
        params.email +
        "&merchantId=" +
        params.merchantId +
        "&pageNo=" +
        (params.pageNo || 0) +
        "&pageSize=" +
        (params.pageSize || 5);
    if (params.unpaidOnly) {
        requestUrl += "&unpaidOnly=true";
    }
    if (params.beginDate) {
        requestUrl += "&beginDate=" + params.beginDate;
    }
    if (params.activePeriod) {
        requestUrl += "&activePeriod=" + params.activePeriod;
    }
    if (params.sortOn) {
        requestUrl += "&sortOn=" + params.sortOn;
    }
    return axios.get(requestUrl, { headers: authHeader() }).then(extract);
};

export const fetchUsageDetails = params => {
    let requestUrl =
        "/api/users/" +
        params.userId +
        "/getUsageDetails?email=" +
        params.email +
        "&merchantId=" +
        params.merchantId +
        "&startDateMillisec=" +
        params.startDateMillisec +
        "&endDateMillisec=" +
        params.endDateMillisec;
    return axios.get(requestUrl, { headers: authHeader() }).then(extract);
};

export const fetchUsageSummary = params => {
    let requestUrl =
        "/api/users/" +
        params.userId +
        "/getUsageSummary?email=" +
        params.email +
        "&merchantId=" +
        params.merchantId +
        "&pageNo=" +
        (params.pageNo || 0) +
        "&pageSize=" +
        (params.pageSize || 5);
    if (params.startDateMillisec) {
        requestUrl += "&startDateMillisec=" + params.startDateMillisec;
    }
    if (params.endDateMillisec) {
        requestUrl += "&endDateMillisec=" + params.endDateMillisec;
    }
    return axios.get(requestUrl, { headers: authHeader() }).then(extract);
};

export const fetchPurchaseDetails = params => {
    let requestUrl = "/api/users/" + params.userId + "/getInvoiceDetails?paymentRef=" + params.paymentRef;
    return axios.get(requestUrl, { headers: authHeader() }).then(extract);
};

export const fetchPricingPlans = () => {
    return axios.get("/api/pricingPlan").then(extract);
};

export const fetchAllFeatures = userId => {
    let requestUrl = "/api/features";
    if (userId) {
        requestUrl += "?userId=" + userId;
    }
    return axios.get(requestUrl).then(extract);
};

export const fetchEnvConfigs = async () => {
    return axios.get("/api/getConfigs").then(extract);
};

export const fetchTopTenTokensByValue = params => {
    let url = `/api/hts/tokens/stats/value`;
    const esc = encodeURIComponent;
    const queryStr = Object.keys(params)
        .map(p => esc(p) + "=" + esc(params[p]))
        .join("&");
    url += `?${queryStr}`;
    return axios.get(url).then(extract);
};

export const fetchTopTenTokensByVolume = params => {
    let url = `/api/hts/tokens/stats`;
    const esc = encodeURIComponent;
    const queryStr = Object.keys(params)
        .map(p => esc(p) + "=" + esc(params[p]))
        .join("&");
    url += `?${queryStr}`;
    return axios.get(url).then(extract);
};

export const searchToken = (params, filterQuery) => {
    let url = `/api/hts/tokens`;
    // let queryParams = [];
    const esc = encodeURIComponent;
    let queryStr = Object.keys(params)
        .map(p => esc(p) + "=" + esc(params[p]))
        .join("&");
    if (filterQuery) {
        queryStr += `&${filterQuery}`;
    }
    // if (params['tokenId']) {
    // 	queryParams.push(`tokenId=${params['tokenId']}`);
    // }
    // if (params['q']) {
    // 	queryParams.push(`q=${params['q']}`);
    // }
    // url += `?${queryParams.join('&')}`;
    url += `?${queryStr}`;
    return axios.get(url).then(extract);
};

export const searchTransfers = (params, withoutTokenId) => {
    let url = `/api/hts/tokens/${params.tokenId}/transfers`;
    if (withoutTokenId) {
    url = `/api/hts/token/transfers`;
    }
    let queryParams = [];
    if (params["transactionId"]) {
        queryParams.push(`transactionId=${params["transactionId"]}`);
    }
    if (params["q"]) {
        queryParams.push(`query=${params["q"]}`);
    }
    if (params["accountId"]) {
        queryParams.push(`accountId=${params["accountId"]}`);
    }
    if (params["from"]) {
        queryParams.push(`from=${params["from"]}`);
    }
    if (params["limit"]) {
        queryParams.push(`size=${params["limit"]}`);
    }
    if (params["offset"]) {
        queryParams.push(`offset=${params["offset"]}`);
    }
    if (params["sort"]) {
        queryParams.push(`sortOn=${params["sort"]}`);
    }
    if (params["order"]) {
        queryParams.push(`sortBy=${params["order"]}`);
    }
    url += `?${queryParams.join("&")}`;
    return axios.get(url).then(extract);
};

export const searchTokenTransactions = params => {
    let url = `/api/hts/tokens/${params.tokenId}/transactions`;
    let queryParams = [];
    if (params["from"]) {
        queryParams.push(`from=${params["from"]}`);
    }
    if (params["limit"]) {
        queryParams.push(`size=${params["limit"]}`);
    }
    if (params["offset"]) {
        queryParams.push(`offset=${params["offset"]}`);
    }
    if (params["sort"]) {
        queryParams.push(`sortOn=${params["sort"]}`);
    }
    if (params["order"]) {
        queryParams.push(`sortBy=${params["order"]}`);
    }
    url += `?${queryParams.join("&")}`;
    return axios.get(url).then(extract);
};

export const fetchTokenBalancesForAccount = params => {
    let url = `/api/hts/tokens/accounts/${params.accountId}/balances`;
    let queryParams = [];
    if (params["from"]) {
        queryParams.push(`from=${params["from"]}`);
    }
    if (params["limit"]) {
        queryParams.push(`size=${params["limit"]}`);
    }
    if (params["size"]) {
        queryParams.push(`size=${params["size"]}`);
    }
    if (params["offset"]) {
        queryParams.push(`offset=${params["offset"]}`);
    }
    if (params["sort"]) {
        queryParams.push(`sortOn=${params["sort"]}`);
    }
    if (params["order"]) {
        queryParams.push(`sortBy=${params["order"]}`);
    }
    url += `?${queryParams.join("&")}`;
    console.log('balances', url)
    return axios.get(url).then(extract);
};

export const fetchTokenTxnVolume = params => {
    let url = `/api/hts/tokens/${params.tokenId}/stats/count`;
    let queryParams = [];
    if (params["interval"]) {
        queryParams.push(`interval=${params["interval"]}`);
    }
    url += `?${queryParams.join("&")}`;
    return axios.get(url).then(extract);
};

export const fetchTokenTxnValue = params => {
    let url = `/api/hts/tokens/${params.tokenId}/stats/value`;
    let queryParams = [];
    if (params["interval"]) {
        queryParams.push(`interval=${params["interval"]}`);
    }
    url += `?${queryParams.join("&")}`;
    return axios.get(url).then(extract);
};

export const fetchNftsDetails = query => {
    let url = `/api/nfts/nfts`;
    let queryParams = [];
    if (query["name"]) {
        queryParams.push(`name=${query["name"]}`);
    }
    if (query["owner"]) {
        queryParams.push(`owner=${query["owner"]}`);
    }
    if (query["creator"]) {
        queryParams.push(`creator=${query["creator"]}`);
    }
    if (query["serialNumber"]) {
        queryParams.push(`serialNumber=${query["serialNumber"]}`);
    }
    if (query["tokenId"]) {
        queryParams.push(`tokenId=${query["tokenId"]}`);
    }
    if (query["sort"]) {
        queryParams.push(`sort=${query["sort"]}`);
    }
    if (query["order"]) {
        queryParams.push(`sortBy=${query["order"]}`);
    }
    if (query["offset"]) {
        queryParams.push(`offset=${query["offset"]}`);
    }
    if (query["limit"]) {
        queryParams.push(`limit=${query["limit"]}`);
    }
    if (query["page"]) {
        queryParams.push(`page=${query["page"]}`);
    }
    if (query["size"]) {
        queryParams.push(`size=${query["size"]}`);
    }
    if (query["q"]) {
        queryParams.push(`query=${query["q"]}`);
    }
    if (query["query"]) {
        queryParams.push(`query=${query["query"]}`);
    }
    if (query["startDate"]) {
        const utcDate = new Date(query["startDate"]).toISOString();
        queryParams.push(`createdAfter=${utcDate}`);
    }
    if (query["endDate"]) {
        const utcDate = new Date(query["endDate"]).toISOString();
        queryParams.push(`createdBefore=${utcDate}`);
    }
    if (query["onlyCount"]) {
        queryParams.push(`onlyCount=${query["onlyCount"]}`);
    }

    if (query["Tokens"] && Object.keys(query["Tokens"]).length !== 0) {
        const filterQuery = Object.keys(query["Tokens"])
			.map((f) => {
				const values = query["Tokens"][f];
				return `tokenId=${values}`
			})
			.join('&');
        queryParams.push(`${filterQuery}`);
    }

    if (query["Owners"] &&  Object.keys(query["Owners"]).length !== 0) {
        const filterQuery = Object.keys(query["Owners"])
			.map((f) => {
				const values = query["Owners"][f];
				return `owner=${values}`
			})
			.join('&');
        queryParams.push(`${filterQuery}`);
    }

    if (query["mintTransactionId"]) {
        queryParams.push(`mintTransactionId=${query["mintTransactionId"]}`);
    }

    url += `?${queryParams.join("&")}`;
    return axios.get(url).then(extract);
};

export const fetchNftsHistoricalDetails = query => {
    let url = `/api/nfts/nfts-transfers`;
    let queryParams = [];

    if (query["transactionId"]) {
        queryParams.push(`transactionId=${query["transactionId"]}`);
    }
    if (query["q"]) {
        queryParams.push(`query=${query["q"]}`);
    }
    if (query["account"]) {
        queryParams.push(`account=${query["account"]}`);
    }
    if (query["tokenId"]) {
        queryParams.push(`tokenId=${query["tokenId"]}`);
    }
    if (query["serialNumber"]) {
        queryParams.push(`serialNumber=${query["serialNumber"]}`);
    }
    if (query["limit"]) {
        queryParams.push(`limit=${query["limit"]}`);
    }
    if (query["offset"]) {
        queryParams.push(`offset=${query["offset"]}`);
    }
    if (query["sort"]) {
        queryParams.push(`sortOn=${query["sort"]}`);
    }
    if (query["order"]) {
        queryParams.push(`sortBy=${query["order"]}`);
    }
    if (query["page"]) {
        queryParams.push(`page=${query["page"]}`);
    }
    url += `?${queryParams.join("&")}`;
    return axios.get(url).then(extract);
};

export const fetchChartAllTransaction = params => {
    let url = `/api/charts/allTransactions`;
    let queryParams = [];
    if (params["interval"]) {
        queryParams.push(`interval=${params["interval"]}`);
    }
    if (params["period"]) {
        queryParams.push(`period=${params["period"]}`);
    }
    if (params["consensusStartInEpoch"]) {
        queryParams.push(`consensusStartInEpoch=${params["consensusStartInEpoch"]}`);
    }
    url += `?${queryParams.join("&")}`;
    return axios.get(`${url}`).then(extract);
};

export const fetchTransactionTypeDimension = params => {
    let url = `/api/charts/transactionTypeDimension`;
    let queryParams = [];
    if (params["interval"]) {
        queryParams.push(`interval=${params["interval"]}`);
    }
    if (params["period"]) {
        queryParams.push(`period=${params["period"]}`);
    }
    if (params["consensusStartInEpoch"]) {
        queryParams.push(`consensusStartInEpoch=${params["consensusStartInEpoch"]}`);
    }
    url += `?${queryParams.join("&")}`;
    return axios.get(`${url}`).then(extract);
};

export const fetchAccountsCreated = params => {
    let url = `/api/charts/accountsCreated`;
    let queryParams = [];
    if (params["interval"]) {
        queryParams.push(`interval=${params["interval"]}`);
    }
    if (params["period"]) {
        queryParams.push(`period=${params["period"]}`);
    }
    if (params["consensusStartInEpoch"]) {
        queryParams.push(`consensusStartInEpoch=${params["consensusStartInEpoch"]}`);
    }
    url += `?${queryParams.join("&")}`;
    return axios.get(`${url}`).then(extract);
};

export const fetchNftMinted = params => {
    let url = `/api/charts/nftMinted`;
    let queryParams = [];
    if (params["interval"]) {
        queryParams.push(`interval=${params["interval"]}`);
    }
    if (params["period"]) {
        queryParams.push(`period=${params["period"]}`);
    }
    if (params["consensusStartInEpoch"]) {
        queryParams.push(`consensusStartInEpoch=${params["consensusStartInEpoch"]}`);
    }
    url += `?${queryParams.join("&")}`;
    return axios.get(`${url}`).then(extract);
};

export const fetchNftTransfer = params => {
    let url = `/api/charts/nftTransfer`;
    let queryParams = [];
    if (params["interval"]) {
        queryParams.push(`interval=${params["interval"]}`);
    }
    if (params["period"]) {
        queryParams.push(`period=${params["period"]}`);
    }
    if (params["consensusStartInEpoch"]) {
        queryParams.push(`consensusStartInEpoch=${params["consensusStartInEpoch"]}`);
    }
    url += `?${queryParams.join("&")}`;
    return axios.get(`${url}`).then(extract);
};

export const fetchTokenTransfer = params => {
    let url = `/api/charts/tokenTransfer`;
    let queryParams = [];
    if (params["interval"]) {
        queryParams.push(`interval=${params["interval"]}`);
    }
    if (params["period"]) {
        queryParams.push(`period=${params["period"]}`);
    }
    if (params["consensusStartInEpoch"]) {
        queryParams.push(`consensusStartInEpoch=${params["consensusStartInEpoch"]}`);
    }
    url += `?${queryParams.join("&")}`;
    return axios.get(`${url}`).then(extract);
};

export const fetchTokenMinted = params => {
    let url = `/api/charts/tokenMinted`;
    let queryParams = [];
    if (params["interval"]) {
        queryParams.push(`interval=${params["interval"]}`);
    }
    if (params["period"]) {
        queryParams.push(`period=${params["period"]}`);
    }
    if (params["consensusStartInEpoch"]) {
        queryParams.push(`consensusStartInEpoch=${params["consensusStartInEpoch"]}`);
    }
    url += `?${queryParams.join("&")}`;
    return axios.get(`${url}`).then(extract);
};

export const fetchLatestCollection = query => {
    let url = `/api/nfts/nfts-collections`;
    let queryParams = [];
    
    if (query["order"]) {
        queryParams.push(`sortBy=${query["order"]}`);
    }
    if (query["offset"]) {
        queryParams.push(`offset=${query["offset"]}`);
    }
    if (query["limit"]) {
        queryParams.push(`limit=${query["limit"]}`);
    }
    if (query["page"]) {
        queryParams.push(`page=${query["page"]}`);
    }
    if (query["nftLimit"]) {
        queryParams.push(`nftLimit=${query["nftLimit"]}`);
    }
    if (query["nftPage"]) {
        queryParams.push(`nftPage=${query["nftPage"]}`);
    }
    if (query["nftoffset"]) {
        queryParams.push(`nftoffset=${query["nftoffset"]}`);
    }
    if (query["tokenID"]) {
        queryParams.push(`tokenID=${query["tokenID"]}`);
    }
    if (query["query"]) {
        queryParams.push(`query=${query["query"]}`);
    }
    if (query["name"]) {
        queryParams.push(`name=${query["name"]}`);
    }
    if (query["createdAfter"]) {
        const utcDate = new Date(query["createdAfter"]).toISOString();
        queryParams.push(`createdAfter=${utcDate}`);
    }
    if (query["createdBefore"]) {
        const utcDate = new Date(query["createdBefore"]).toISOString();
        queryParams.push(`createdBefore=${utcDate}`);
    }

    url += `?${queryParams.join("&")}`;
    return axios.get(`${url}`).then(extract);
};

export const fetchActiveCollection = query => {
    let url = `/api/nfts/nfts-active-collections`;
    let queryParams = [];
    
    if (query["order"]) {
        queryParams.push(`sortBy=${query["order"]}`);
    }
    if (query["offset"]) {
        queryParams.push(`offset=${query["offset"]}`);
    }
    if (query["limit"]) {
        queryParams.push(`limit=${query["limit"]}`);
    }
    if (query["page"]) {
        queryParams.push(`page=${query["page"]}`);
    }
    if (query["nftLimit"]) {
        queryParams.push(`nftLimit=${query["nftLimit"]}`);
    }
    if (query["nftPage"]) {
        queryParams.push(`nftPage=${query["nftPage"]}`);
    }
    if (query["nftoffset"]) {
        queryParams.push(`nftoffset=${query["nftoffset"]}`);
    }
    if (query["tokenID"]) {
        queryParams.push(`tokenID=${query["tokenID"]}`);
    }

    url += `?${queryParams.join("&")}`;
    return axios.get(`${url}`).then(extract);
};

export const fetchOwnerCollection = query => {
    let url = `/api/nfts/nfts-owner-collections`;
    let queryParams = [];
    
    if (query["offset"]) {
        queryParams.push(`offset=${query["offset"]}`);
    }
    if (query["limit"]) {
        queryParams.push(`limit=${query["limit"]}`);
    }
    if (query["page"]) {
        queryParams.push(`page=${query["page"]}`);
    }
    if (query["owner"]) {
        queryParams.push(`owner=${query["owner"]}`);
    }
    if (query["query"]) {
        queryParams.push(`query=${query["query"]}`);
    }

    url += `?${queryParams.join("&")}`;
    return axios.get(`${url}`).then(extract);
};

export const fetchStaticCount = () => {
    return axios.get(`/api/stats/counts/static`).then(extract);
};

export const fetchJSONdata = (base64Id) => {
    return axios.get(`https://dropp-nft.infura-ipfs.io/ipfs/${base64Id}`).then(extract);
};

export const fetchJSONdataByUrl = (url, base64) => {
    return axios.post("/api/nfts/nft-metadata", { url, base64 }).then(extract);
};

export const nftMarketplaceRequest = nftMarketPlaceBody => {
    return axios.post("/api/nftMarketPlace/register", { ...nftMarketPlaceBody }).then(extract);
};

export const fetchImage = (url) => {
    return fetch(`${url}`).then(extract);
};